var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { StateProvider } from '../../services/state-provider';
import { Banner } from '@idp/ui-components';
import { CMS } from '@idp/cms-integration';
import { CatalogDataType, appShellNameSpace, LobStateManagerNameSpaces } from '../MainView/MainView.container.props';
import { ICCEventBusManager } from '@idp/event-bus';
import * as styles from './BannerContainer.scss';
import { getCatalogDataType, getCMSFeedName } from '../../utils/UtilityFunctions';
var stateBannnerDataStr = 'BannerData';
var cmsBannerDataStr = 'cmsBannerData';
var BannerContainer = /** @class */ (function (_super) {
    __extends(BannerContainer, _super);
    function BannerContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.registerDtvsBanner = _this.registerDtvsBanner.bind(_this);
        return _this;
    }
    BannerContainer.prototype.componentDidMount = function () {
        this.registerDtvsBanner();
    };
    BannerContainer.prototype.registerDtvsBanner = function () {
        var _this = this;
        var lobList = LobStateManagerNameSpaces.filter(function (namespace) { return (namespace !== appShellNameSpace); });
        lobList.forEach(function (lob) {
            var observer = {
                eventHandler: function () { _this.updateState(lob); },
                observerId: ICCEventBusManager.getUUID(),
                serviceName: lob + ':' + stateBannnerDataStr,
            };
            ICCEventBusManager.getInstance().registerObserver(observer);
        });
    };
    BannerContainer.prototype.updateState = function (namespace) {
        var bannerData = this.stateManager.get(namespace, stateBannnerDataStr);
        if (bannerData && bannerData.length > 0) {
            this.setState(function () { return ({ bannerStateData: bannerData }); });
            this.stateManager.set(stateBannnerDataStr, bannerData);
        }
    };
    BannerContainer.prototype.getBannerData = function () {
        var bannerData = [];
        var stateBannerData = this.stateManager.get(appShellNameSpace, stateBannnerDataStr);
        if (stateBannerData) {
            stateBannerData.forEach(function (statedata) {
                if (statedata) {
                    bannerData.push({ data: statedata });
                }
            });
        }
        var bundleType = getCatalogDataType();
        var cmsDataAttrName = getCMSFeedName();
        var cmsBannerData = cmsDataAttrName ? CMS.get({}, cmsDataAttrName).content.alertBanner : null;
        var cmsBanner = [];
        if (bundleType === CatalogDataType.DTV) {
            var baseUrl = this.stateManager.get(appShellNameSpace, 'baseURL') || { url: '' };
            var isDirectvCom = location.href.toLowerCase().indexOf('directv.com') > -1 || baseUrl.url.toLowerCase().indexOf('directv.com') > -1;
            var keyType = location.href.indexOf('CMP=') > -1 || baseUrl.url.indexOf('CMP=') > -1 ? 'CMP' : isDirectvCom ? 'directv.com' : '';
            var isTFNbanner = keyType !== '' ? true : false;
            cmsBanner = this.fetchValuesFromCMS(cmsBannerData, keyType, isDirectvCom, isTFNbanner);
        }
        else {
            cmsBanner = this.fetchValuesFromCMS(cmsBannerData, null, false, false);
        }
        if (cmsBanner && cmsBanner.length <= 0) {
            cmsBanner = this.stateManager.get(appShellNameSpace, cmsBannerDataStr);
        }
        else {
            this.stateManager.set(cmsBannerDataStr, cmsBanner);
        }
        if (cmsBanner) {
            cmsBanner.forEach(function (cmsBnnr) {
                if (cmsBnnr) {
                    bannerData.push(cmsBnnr);
                }
            });
        }
        return bannerData;
    };
    BannerContainer.prototype.render = function () {
        var bannerData = this.getBannerData();
        var banner = [];
        if (bannerData && bannerData.length > 0) {
            bannerData.forEach(function (element) {
                banner.push(React.createElement(Banner, { data: __assign({}, element.data), options: __assign({}, element.options) }));
            });
        }
        return (banner.concat());
    };
    BannerContainer.prototype.fetchValuesFromCMS = function (cmsData, customKey, fetchDefalut, isTFNBanner) {
        var _this = this;
        var baseUrl = this.stateManager.get('appShell', 'baseURL');
        var cmsConfiguration = cmsData && cmsData.configuration ? cmsData.configuration : [];
        // Check for passed in values
        var cmsBannerData = [];
        cmsConfiguration.forEach(function (element) {
            if (customKey === null || customKey === undefined ||
                (element.keyType === customKey &&
                    (location.href.indexOf(element.keyValue) > -1 || baseUrl.url.indexOf(element.keyValue) > -1))) {
                cmsBannerData.push(_this.populateBannerData(element, isTFNBanner));
                return cmsBannerData;
            }
        });
        if (fetchDefalut && !cmsBannerData) {
            var cmsBannerElement = cmsConfiguration.find(function (element) { return element.keyValue === 'default'; });
            if (cmsBannerElement) {
                cmsBannerData.push(this.populateBannerData(cmsBannerElement, isTFNBanner));
            }
        }
        return cmsBannerData;
    };
    BannerContainer.prototype.populateBannerData = function (config, istfnbanner) {
        var desktoptext = config.desktopSubHeadingText ? '<span>' + config.desktopText + '</span></BR><span>' + config.desktopSubHeadingText + '</span>' : config.desktopText;
        var mobiletext = config.mobileSubHeadingText ? '<span>' + config.mobileText + '</span></BR><span>' + config.mobileSubHeadingText + '</span>' : config.mobileText;
        return {
            data: {
                bgColor: config.bgColor,
                desktopText: desktoptext,
                fontColor: config.fontColor,
                icontype: config.icontype,
                isTFNBanner: istfnbanner,
                mobileText: mobiletext,
                modalData: config.modalData,
                modalHeading: config.modalHeading,
                modalLinkLabel: config.modalLinkLabel,
            },
            options: {
                className: config.isOneMonthBanner === true ? styles.oneMonthBanner : '',
            },
        };
    };
    return BannerContainer;
}(React.Component));
export default BannerContainer;
//# sourceMappingURL=BannerContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/BannerContainer/BannerContainer.js
// module id = 942
// module chunks = 8